var render = function render(){var _vm=this,_c=_vm._self._c;return _c('arrayed-url-field',_vm._b({attrs:{"placeholder":"Website","url-type":"website"},on:{"change":function($event){return _vm.$emit('change', $event)},"source-change":function($event){return _vm.$emit('source-change', $event)}}},'arrayed-url-field',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }